/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { coreService } from 'network-utils';
import { FC } from 'react';
import { translate } from 'translations';
import styles from './inventoryItem.module.scss';

const InventoryItem: FC<InventoryItemProps> = (props: InventoryItemProps) => {
    const { type, numberOfItems } = props;
    const typesImages = {
        course: {
            topIcon: `${process.env.PUBLIC_URL}/images/courseTopIcon.svg`,
            mainImage: `${process.env.PUBLIC_URL}/images/courseElement.webp`,
            name: translate('Courses')
        },
        lesson: {
            topIcon: `${process.env.PUBLIC_URL}/images/lessonTopIcon.svg`,
            mainImage: `${process.env.PUBLIC_URL}/images/lessonElement.png`,
            name: translate('Lessons')
        },
        challenge: {
            topIcon: `${process.env.PUBLIC_URL}/images/challengeTopIcon.svg`,
            mainImage: `${process.env.PUBLIC_URL}/images/challengeElement.svg`,
            name: translate('Challenges')
        },
        systemAssessment: {
            topIcon: `${process.env.PUBLIC_URL}/images/assessmentTopIcon.svg`,
            mainImage: `${process.env.PUBLIC_URL}/images/assessmentElement.svg`,
            name: translate('Assessments')
        }
    };

    return (
        <>
            <div className={styles['inventory-item-wrapper']}>
                <div className={styles['image-wrapper']}>
                    <img src={typesImages[type].topIcon} className={styles['top-icon']} alt="topIcon" />
                    <img src={typesImages[type].mainImage} className={styles['main-image']} alt="midImage" />
                </div>
            </div>
            <div className={styles.name}>{`${typesImages[type].name} ${numberOfItems}`}</div>
        </>
    );
};

export interface InventoryItemProps {
    type: coreService.LearningPathContentType;
    numberOfItems: number;
}

export default InventoryItem;
